// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 425) return "static/chunks/2170a4aa-9e8654eaa60d280f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "314acc5a498d9a7a" + ".js";
};